var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"global_wrapper apply apply-help newform1 applicant-payment\"><navbar></navbar><!--Sub Navbar for Payment Flow--><div ng-if=\"display_progress_bar\" class=\"row top\"><ul ng-style=\"{width: progress_bar_width }\"><li class=\"form-step-1\"><img src=\"{{step1}}\" width=\"25\" alt=\"\" style=\"margin: 0 auto;\"><h3 ng-class=\"{active: active_mapping.income }\">Income</h3></li><li ng-class=\"{ready: ready_mapping.income}\" class=\"line line-step-2\"></li><li class=\"form-step-2\"><img src=\"{{step2}}\" width=\"25\" alt=\"\" style=\"margin: 0 auto;\"><h3 ng-class=\"{active: active_mapping.payment}\">Payment</h3></li><li ng-class=\"{ready: ready_mapping.payment}\" class=\"line line-step-3\"></li><li class=\"form-step-3\"><img src=\"{{step3}}\" width=\"25\" alt=\"\" style=\"margin: 0 auto;\"><h3 ng-class=\"{active: active_mapping.complete }\">Complete</h3></li></ul></div><div ui-view=\"\"></div><div class=\"button-blue\"><div class=\"container\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/payment/payment.jade
// module id = 1126
// module chunks = 0